import { Alert, AlertIcon, Box, SimpleGrid, Text } from '@chakra-ui/react'

import { ActionButton } from '../../../../components/ActionButton'
import ImageCropInput from '../../../../components/ImageCropInput/ImageCropInput'
import { TContestBackgroundStep, TContestBackgrounds } from './types'

interface IProps {
  backgrounds: TContestBackgrounds
  onChange: (step: TContestBackgroundStep, value: File | null) => void
  errors: Record<string, string>
  saving: boolean
  /** The contest was already created and only its backgrounds failed to upload. */
  isContestCreated?: boolean
}

const STEP_LABELS: Record<TContestBackgroundStep, string> = {
  menu: 'Fundo da tela de opções',
  registration: 'Fundo da etapa de inscrição',
  submission: 'Fundo da etapa de envio das obras'
}

/** Custom backgrounds of the public options screen (ABRA-348), registration and artwork submission pages (ABRA-336). */
export function AppearanceTab({ backgrounds, onChange, errors, saving, isContestCreated = false }: IProps) {
  return (
    <Box>
      {isContestCreated && (
        <Alert status="warning" rounded="lg" mb={4}>
          <AlertIcon />O concurso já foi criado, mas as imagens de fundo não foram enviadas. Corrija as imagens e envie
          de novo, ou feche para manter o concurso sem elas.
        </Alert>
      )}

      <Text variant="caption" mb={4}>
        A imagem cobre a tela inteira da página no site, com uma camada escura por cima para manter o texto legível. No
        celular ela é recortada nas laterais, então evite textos ou detalhes importantes perto das bordas. Sem imagem, a
        página usa o fundo padrão.
      </Text>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
        {(Object.keys(STEP_LABELS) as TContestBackgroundStep[]).map((step) => {
          const error = errors[`${step}_background`]

          return (
            <Box key={step}>
              <ImageCropInput
                label={STEP_LABELS[step]}
                value={backgrounds[step]}
                onChange={(file) => onChange(step, file)}
                accept="coverImage"
                aspectRatio={16 / 9}
                previewAspectRatio="16 / 9"
                suggestedSize="1920 x 1080 px"
                maxSizeMB={5}
                isDisabled={saving}
                error={error ? [error] : undefined}
              />
              {backgrounds[step] && !saving && (
                <ActionButton
                  action="delete"
                  label="Remover fundo"
                  showLabel
                  variant="ghost"
                  mt={2}
                  onClick={() => onChange(step, null)}
                />
              )}
            </Box>
          )
        })}
      </SimpleGrid>
    </Box>
  )
}
